import { Flex } from "@radix-ui/themes";
import { InlineTextField } from "@/components/shared/inputs/inilie-text-field/InlineTextField";
import { CollapsibleFieldList } from "../../../parts/CollapsibleFieldList";
import { FieldGroup, OptionalFieldGroup } from "../../../parts/FieldGroup";

interface GreetingSettingsProps {
  enabled: boolean;
  title: string;
  fallbackUserName: string;
  onEnabledChange: (nextValue: boolean) => void;
  onTitleChange: (value: string) => void;
  onFallbackUserNameChange: (value: string) => void;
}

export function GreetingSettings({
  enabled,
  title,
  fallbackUserName,
  onEnabledChange,
  onTitleChange,
  onFallbackUserNameChange,
}: GreetingSettingsProps) {
  return (
    <CollapsibleFieldList title={"Greeting"} defaultOpen>
      <OptionalFieldGroup
        label={"Show Greeting"}
        description={"Display a greeting at the top of Quack Home."}
        enabled={enabled}
        toggleEnabled={onEnabledChange}
      >
        <Flex width="100%" direction="column">
          <FieldGroup horizontal description={"Greeting title"}>
            <InlineTextField
              value={title}
              onChange={onTitleChange}
              placeholder={"Hello {USER}"}
              disabled={!enabled}
            />
          </FieldGroup>

          <FieldGroup horizontal description={"Fallback user name"}>
            <InlineTextField
              value={fallbackUserName}
              onChange={onFallbackUserNameChange}
              placeholder={"there"}
              disabled={!enabled}
            />
          </FieldGroup>
        </Flex>
      </OptionalFieldGroup>
    </CollapsibleFieldList>
  );
}
